<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    class="enter-button"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.25 4.00003C21.4489 4.00003 21.6397 4.07905 21.7804 4.2197C21.921 4.36035 22 4.55112 22 4.75003L22 11.25C22 12.2446 21.6049 13.1984 20.9017 13.9017C20.1984 14.6049 19.2446 15 18.25 15L4.58502 15L8.30503 18.72C8.43189 18.8471 8.50894 19.0156 8.52215 19.1947C8.53536 19.3738 8.48387 19.5517 8.37703 19.696L8.30503 19.78C8.17798 19.9073 8.00943 19.9847 7.83009 19.9981C7.65076 20.0115 7.47258 19.96 7.32802 19.853L7.24402 19.78L2.24402 14.78C2.11701 14.653 2.03978 14.4847 2.02638 14.3056C2.01299 14.1265 2.06431 13.9485 2.17102 13.804L2.24402 13.72L7.24402 8.72003C7.37802 8.58707 7.55723 8.50953 7.74588 8.50289C7.93454 8.49625 8.11876 8.56099 8.26178 8.68419C8.4048 8.80739 8.4961 8.97999 8.51746 9.16755C8.53882 9.3551 8.48868 9.54382 8.37702 9.69603L8.30503 9.78003L4.58502 13.5L18.25 13.5C18.82 13.4998 19.3686 13.2834 19.7851 12.8943C20.2017 12.5053 20.455 11.9726 20.494 11.404L20.5 11.25L20.5 4.75003C20.5 4.55112 20.579 4.36035 20.7197 4.2197C20.8603 4.07905 21.0511 4.00003 21.25 4.00003Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'EnterButton'
}
</script>
<style lang="sass" scoped>
.enter-button
  fill: currentColor
</style>
